import { LitElement, html } from "lit-element";
import { connect } from "pwa-helpers/connect-mixin.js";
import { getAllDrawings, getAllImagesByDbAndContext } from "../data/images.js";
import "./inspx-db-image.js";
import { add, addPhoto } from "../styles/icons.js";
import { store } from "../inspx-store.js";
import { getContextsIndex } from '../data/images.js'
import { updateImageById, updateDrawingById } from "../actions/inspection.js";
import { DrawingTool } from "../components/drawing/inspx-drawing-tool";
import { SharedStyles } from "../styles/shared-styles.js";

class InspxDbImagesContainer extends connect(store)(LitElement) {
	shouldUpdate(changedProps) {
		if (
			this.inspectionid == undefined &&
            changedProps &&
            changedProps.context != this.context
		)
			return false;

		if (!this.loaded && !this.loading) {
			this.loading = true;
			this.loadProm = this.drawing ? this._loadDrawings() : this._loadImages();
			this.loadProm.then(_ => {
				this.loaded = true;
				this.loading = false;
				this.updateComplete.then(_ => {
					this.tryRestoreScroll();
				})
			});
			this.loaded = false;
		}

		return true;
	}

	render() {

		let content = this.loaded ? this.renderImages() : html`<span>Loading...</span>`;

		return html`
        ${SharedStyles}
        <style>
            :host {
                display: block;
                position: relative;
                height: 100%;
                text-align: center;
            }

            .add-photo{
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: var(--primary-color-variant3);
                border-radius: 4px;
                cursor: pointer;
            }
            .add-photo:hover{
                background-color: var(--primary-color-variant2);
            }
            .add-photo svg {
                width: 50px;
                height: 50px;
                fill: var(--secondary-color);
            }

            .fab {
                    cursor: pointer;
                    position: fixed;
                    right: 40px;
                    background-color: var(--secondary-color);
                    bottom: 20px;
                    border-radius: 50%;
                    width: 42px;
                    height: 42px;
                    align-items: center;
                    display: flex;
                    justify-content: space-around;
                    fill: white;
            }

            @media only screen and (max-width: 460px) {
                inspx-db-image {
                    margin-bottom: 12px;
                }

                .add-photo{
                    height: 50px !important;
                }
            }
        </style>
        
        
            ${content}

        <input type="file" id="fileInput" @change="${this._fileSelected.bind(this)}" accept="image/*" multiple hidden>
        
        ${
	this.hideAddButton || this.isRemote
		? ""
		: html`<div class="fab" @click='${() => this.addPhoto()}'>${add}</div>`}`;
	}

	renderImages() {
		let addPhotoStyle =
            (!this.hideAddButton && this.images.length) > 0
            	? html`
        <style>
            .add-photo{
                height: var(--db-image-height, 150px);
            } 
        </style>`
            	: "";

		let res = html`
            ${addPhotoStyle} 
            ${this.images.map((i) => html`
                <inspx-db-image 
                    ?isRemote = "${this.isRemote}"
                    ?hideContext="${this.hideContext}"
                    .isCover="${this.coverId === i}"
                    .notInReportImages="${this.notInReportImages}"
                    .src='${i}' 
                    .context='${this.contexts[i]}'
                    ?drawing='${this.drawing}'
                    .isInspectionPage='${this.isInspectionPage}'
                    .applyFunc='${(id, updatedData, isDrawing) => this.photoUpdate(id, updatedData, isDrawing)}'></inspx-db-image>`)}
            ${this.renderAddPhoto()}`;

		return res;
	}

	renderAddPhoto() {
		return (!this.hideAddPhoto && !this.isRemote) ? html`<div class='add-photo' @click='${() => this.addPhoto()}'>${addPhoto}</div>` : '';
	}

	_fileSelected(e) {
		const input = e.currentTarget;
		if (input.files.length === 0) return;

		const files = [];
		for (const file of input.files) {
			if (file.size == 0) return;
			files.push(file);
		}
		if (files.length === 0) return;

		this.dispatchEvent(
			new CustomEvent("photos-selected", {
				detail: {
					files: files,
					context: this.context,
					container: this
				},
				composed: true,
				cancellable: true
			})
		);

		e.currentTarget.value = null;
		e.currentTarget.files = null;
	}

	addPhoto() {
		const currState = store.getState();
		const route = currState.app.route;
		route.subpage === "drawings"
			? this.editDrawing()
			: this.shadowRoot.getElementById("fileInput").click();
	}

	constructor() {
		super();
		this.images = [];
		this.coverId = INSP.APP.coverId;
		const page = store.getState().app.route.page;
		this.isInspectionPage = page === "inspection";
		this.contexts = {};
	}

	stateChanged(state) {

		this.isRemote = state.app.route.page.toLowerCase() == "remote-inspection";
		if (this.isRemote && this.subpage != undefined) {
			if (state.app.route.subpage != this.subpage) {
				this.loaded = false;
				this.subpage = state.app.route.subpage;
				return;
			}
		}
		this.subpage = state.app.route.subpage;
		this.coverId = INSP.APP.coverId;
		if (state.inspection.current) {
			this.notInReportImages = state.inspection.current.not_in_report_images
		}

		if (!this.drawing) {
			this.getImagesContexts(state);
		}
	}

	getImagesContexts(state) {
		if (!state.inspection.current) return;

		getContextsIndex(this.inspectionid, "images").then(i => {
			const contexts = {};

			Object.keys(i).forEach(k => {
				contexts[k] = i[k].split('.');
			});

			const inspSchema = state.inspection.current.type.schema;

			Object.keys(contexts).forEach((k) => {
				const c = contexts[k];
				let title = '';
				if (inspSchema.properties && c[0] && inspSchema.properties[c[0]]) {
					if (inspSchema.properties[c[0]].properties) {
						title = `${inspSchema.properties[c[0]].title} - ${inspSchema.properties[c[0]].properties[c[1]].title}`;
					} else {
						title = inspSchema.properties[c[0]].items.title;
					}
				}

				contexts[k] = title;
			});

			this.contexts = contexts;
		});
	}

	static get properties() {
		return {
			loaded: { type: Boolean },
			imageIds: { type: Object },
			drawingIds: { type: Object },
			lastRendered: { type: Number },
			all: { type: Boolean },
			inspectionid: { type: String }, //if undefined, takes current
			hideContext: { type: Boolean },
			drawing: { type: Boolean },
			hideAddButton: { type: Boolean },
			hideAddPhoto: { type: Boolean },
			notInReportImages: { type: Array }
		};
	}

	_loadDrawings() {
		if (this.drawingIds)
			return Promise.resolve(Object.values(this.drawingIds || {})).then(i => {
				this.images = i;
				return i;
			});

		if (this.all) {
			if (this.isRemote) {
				this.images = INSP.APP.state.inspection.remote.drawings.map(i => i.id);
			} else {
				return getAllDrawings(this.inspectionid).then(a => {
					if (!a) return;
					this.images = a.map(i => i.id);
				});
			}
		}

		return Promise.resolve();
	}

	async _loadImages() {
		if (this.imageIds) {
			return Promise.resolve(Object.values(this.imageIds || {})).then(i => {
				this.images = i;
				return i;
			});
		}

		if (this.all) {
			if (this.isRemote) {
				this.images = INSP.APP.state.inspection.remote.images.sort((s, t) => (s.propertyName > t.propertyName) ? 1 : -1).map(i => i.id);
			} else {
				return getAllImagesByDbAndContext(this.inspectionid).then(a => {
					if (!a) return;
					this.images = a.sort((s, t) => (s.propertyName > t.propertyName) ? 1 : -1).map(i => i.id);
				});
			}
		}

		return Promise.resolve();
	}

	__openDrawingTool() {
		let dt = new DrawingTool(false);
		dt.addEventListener('onDrawingToolClosed', () => this.loaded = false);
		document.body.appendChild(dt);
	}

	editDrawing() {
		this.__openDrawingTool();
	}

	photoUpdate(id, updatedData, isDrawing) {
		window.INSP.restoreScroll = document.scrollingElement.scrollTop;
		this.loaded = false;
		isDrawing
			? store.dispatch(updateDrawingById(id, updatedData))
			: store.dispatch(updateImageById(id, updatedData))
	}

	tryRestoreScroll() {
		if (window.INSP.restoreScroll) {
			this.updateComplete.then(_ => {
				document.scrollingElement.scrollTop = window.INSP.restoreScroll;
			});
		}
	}
}

window.customElements.define("inspx-db-images-container", InspxDbImagesContainer);
